import { RefObject, useEffect, useState } from 'react';

/**
 * Returns true once the element has entered the viewport (IntersectionObserver).
 * Stays true after first intersection so data fetch is not cancelled when scrolling away.
 */
const useInView = (ref: RefObject<Element | null>, options?: IntersectionObserverInit): boolean => {
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const element = ref.current;
        if (!element || inView) {
            return undefined;
        }

        if (typeof IntersectionObserver === 'undefined') {
            setInView(true);
            return undefined;
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (entry?.isIntersecting) {
                setInView(true);
                observer.disconnect();
            }
        }, options);

        observer.observe(element);
        return () => {
            observer.disconnect();
        };
    }, [ref, inView, options?.root, options?.rootMargin, options?.threshold]);

    return inView;
};

export default useInView;
